var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62673",
    "data-name": "Group 62673",
    transform: "translate(-86 -309.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16377",
    "data-name": "Rectangle 16377",
    transform: "translate(86 309.57)",
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 25.3,
    rx: 1.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M18.372,19.1H1.9A1.864,1.864,0,0,1,0,17.272V6.325A1.864,1.864,0,0,1,1.9,4.5H18.372a1.864,1.864,0,0,1,1.9,1.825V17.272A1.864,1.864,0,0,1,18.372,19.1ZM4.435,6.629A2.174,2.174,0,0,0,2.217,8.757a2.174,2.174,0,0,0,2.217,2.129A2.174,2.174,0,0,0,6.652,8.757,2.174,2.174,0,0,0,4.435,6.629Zm-1.9,10.035h15.2V12.406L14.274,9.08a.489.489,0,0,0-.672,0L8.236,14.231l-2.2-2.11a.489.489,0,0,0-.672,0L2.534,14.839Z",
    transform: "translate(94.109 310.746)",
    fill: "#babec1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Primary_Button",
    "data-name": "Primary Button",
    transform: "translate(271 316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8874",
    "data-name": "Rectangle 8874",
    width: 33,
    height: 13,
    rx: 2,
    fill: "#0072c6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Submit",
    transform: "translate(8 8)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Submit"))), /*#__PURE__*/React.createElement("g", {
    id: "Primary_Button-2",
    "data-name": "Primary Button",
    transform: "translate(236 316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8874-2",
    "data-name": "Rectangle 8874",
    fill: "#fff",
    stroke: "#0072c6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 13,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 26.5,
    height: 12.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Save",
    transform: "translate(8 8)",
    fill: "#0072c6",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Save"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader2);
export default __webpack_public_path__ + "static/media/header2.fb5cba62bdf52eb44b4af915630a02d8.svg";
export { ForwardRef as ReactComponent };